
export default async function cpmSchedule (
    noPredTasks: any[],
    noSuccTasks: any[],
    tasksMap: Map<any, any>,
    calendarsMap: Map<any, any>,
    projectId: string,
    db,
    latestDate: number,
    cpmRefresh: boolean
) {
    let cpmMap = tasksMap
    const timeStart = new Date().getTime()

    const mcdCache = new Map<string, any>();
    const scdCache = new Map<string, any>();
    const mwpCache = new Map<string, any>();

    const mcd = (sec:number, cal:string) => {
        const k = sec + '|' + cal; let v = mcdCache.get(k);
        if (v !== undefined) return v;
        v = calendarsMap.get(`mcd:${sec}:${cal}`);
        mcdCache.set(k, v); return v;
    };
    const scd = (idx:number, cal:string) => {
        const k = idx + '|' + cal; let v = scdCache.get(k);
        if (v !== undefined) return v;
        v = calendarsMap.get(`scd:${cal}:${idx}`);
        scdCache.set(k, v); return v;
    };
    const mwp = (idx:number, cal:string) => {
        const k = idx + '|' + cal; let v = mwpCache.get(k);
        if (v !== undefined) return v;
        v = calendarsMap.get(`mwp:${idx}:${cal}`);
        mwpCache.set(k, v); return v;
    };

    const masterCalendarDict = (seconds, calendarId) => {
        return mcd(seconds, calendarId)
    }

    const specificCalendarDict = (index, calendarId) => {
        return scd(index, calendarId)
    }

    const masterWorkPatternDict = (index, calendarId) => {
        return mwp(index, calendarId)
    }
    let globalLateFinish = latestDate

    function convertIndexToSeconds(index, calendarId) {
        const date = specificCalendarDict(index, calendarId)
        if (isNaN(date)) {
            return convertOutOfRangeIndexToDate(index, calendarId)
        } else {
            return date
        }
    }

    function generateTask(taskId) {
        return cpmMap.get(taskId)
    }

    function generateLink(linkId) {
        return cpmMap.get(linkId)
    }

    function convertOutOfRangeIndexToDate(index, calendarId) {
        const maxDate = calendarsMap.get(`swp:maxDate:${calendarId}`)
        const maxIndex = calendarsMap.get(`swp:maxIndex:${calendarId}`)
        // const weeklyIndices = specificWorkPatternDict[calendarId].weeklyIndices
        const halfHours = calendarsMap.get(`swp:wi:count:${calendarId}`)
        const weeks = Math.floor((index - maxIndex) / halfHours)
        const maxWeekIndex = calendarsMap.get(`swp:maxWeekIndex:${calendarId}`)
        const relativeMaxWeekIndex = masterWorkPatternDict(maxWeekIndex, calendarId)
        const relativeMaxDayIndex = calendarsMap.get(`swp:maxDayIndex:${calendarId}`)
        const relativeMaxHalfHourIndex = calendarsMap.get(`swp:wi:h:${calendarId}:${relativeMaxWeekIndex}`)
        const remainingHalfHours = index - maxIndex - (weeks * halfHours)
        const newIndex = remainingHalfHours + relativeMaxWeekIndex > halfHours ? (remainingHalfHours + relativeMaxWeekIndex) - halfHours : remainingHalfHours + relativeMaxWeekIndex
        const newWeekDayIndex = calendarsMap.get(`swp:wi:d:${calendarId}:${newIndex}`)
        const additionalDays = relativeMaxWeekIndex + remainingHalfHours > halfHours ? 7 - relativeMaxDayIndex + newWeekDayIndex : newWeekDayIndex - relativeMaxDayIndex

        return maxDate + (weeks * 604800) + (additionalDays * 86400) + ((calendarsMap.get(`swp:wi:h:${calendarId}:${newIndex}`) - relativeMaxHalfHourIndex) * 1800)
    }

    function convertOutOfRangeDateToIndex(date, calendarId) {
        const maxDate = calendarsMap.get(`swp:maxDate:${calendarId}`)
        const maxIndex = calendarsMap.get(`swp:maxIndex:${calendarId}`)
        const halfHours = calendarsMap.get(`swp:wi:count:${calendarId}`)
        const weeks = Math.floor((date - maxDate) / 604800)
        const maxWeekIndex = calendarsMap.get(`swp:maxWeekIndex:${calendarId}`)
        const relativeMaxWeekIndex = masterWorkPatternDict(maxWeekIndex, calendarId)
        const remainingHalfHours = Math.floor((date - maxDate) / 1800) - (weeks * 336)
        const newMasterIndex = remainingHalfHours + maxWeekIndex > 336 ? (remainingHalfHours + maxWeekIndex) - 336 : remainingHalfHours + maxWeekIndex
        const newCalendarSpecificIndex = masterWorkPatternDict(newMasterIndex, calendarId)

        return  remainingHalfHours + maxWeekIndex > 336 ? maxIndex + (weeks * halfHours) + (halfHours - relativeMaxWeekIndex) + (newCalendarSpecificIndex) :
            maxIndex + (weeks * halfHours) + (newCalendarSpecificIndex - relativeMaxWeekIndex)
    }

    function getOutOfRangeLateralIndex (index, calendarId, lateralCalendarId, addOn) {
        if (calendarId === lateralCalendarId) {
            return index + addOn
        }
        const date = convertOutOfRangeIndexToDate(index, calendarId)
        const maxDate = calendarsMap.get(`swp:maxDate:${lateralCalendarId}`)
        const maxIndex = calendarsMap.get(`swp:maxIndex:${lateralCalendarId}`)
        const weekCount = Math.floor((date - maxDate - 1800 - (3 * 86400)) / 604800)
        const weekHalfHourCount = calendarsMap.get(`swp:wi:count:${lateralCalendarId}`)
        const weekIndexDatePlusWeeks = (((maxDate + (weekCount * 604800)) - 1800 - (3 * 86400)) -
            Math.floor(((maxDate + (weekCount * 604800)) - 1800 - (3 * 86400)) / 604800) * 604800) / 1800
        const correspondingCalendarIndexDatePlusWeeks = masterWorkPatternDict(weekIndexDatePlusWeeks, lateralCalendarId)
        const weekIndexDate = ((date - 1800 - (3 * 86400)) - Math.floor((date - 1800 - (3 * 86400)) / 604800) * 604800) / 1800
        const correspondingCalendarIndexDate = masterWorkPatternDict(weekIndexDate, lateralCalendarId)
        const indicesToAdd = correspondingCalendarIndexDatePlusWeeks < correspondingCalendarIndexDate ?
            correspondingCalendarIndexDate - correspondingCalendarIndexDatePlusWeeks :
            weekHalfHourCount - correspondingCalendarIndexDatePlusWeeks + correspondingCalendarIndexDate

        return maxIndex + (weekCount * weekHalfHourCount) + indicesToAdd + addOn
    }

    const handleTypes = {
        'TT_LOE': 0,
        'TT_FinMile': 1,
        'TT_Mile': 0,
        'TT_Task': 0,
        'TT_Rsrc': 0,
        'TT_WBS': 0,
        'TT_TASK': 0,
        'TT_RSRC': 0,
        'TT_MILE': 0,
        'TT_FINMILE': 1,
    }

    const handlePredTypes = {
        'TT_LOE': 0,
        'TT_FinMile': 0,
        'TT_Mile': 1,
        'TT_Task': 0,
        'TT_Rsrc': 0,
        'TT_WBS': 0,
        'TT_TASK': 0,
        'TT_RSRC': 0,
        'TT_MILE': 1,
        'TT_FINMILE': 0,
    }

    const handleTypesBp = {
        'TT_LOE': 0,
        'TT_FinMile': 0,
        'TT_Mile': -1,
        'TT_Task': -1,
        'TT_Rsrc': -1,
        'TT_WBS': 0,
        'TT_TASK': -1,
        'TT_RSRC': -1,
        'TT_MILE': -1,
        'TT_FINMILE': 0,
    }

    const handleTaskStatus = {
        'not started': 1,
        'in progress': 1,
        'block': 1,
        'suspended': 1,
        'completed': 0,
        'declared complete': 0,
    }

    function getLateralIndex(idx:number, calA:string, calB:string, addOn:number){
        if (calA === calB) return idx + addOn;
        const secs = scd(idx, calA);                 // memoized
        const toIdx = mcd(secs, calB);               // memoized
        if (!Number.isNaN(toIdx)) return toIdx + addOn;
        // rare: out-of-range path
        return getOutOfRangeLateralIndex(idx, calA, calB, addOn);
    }

    function checkRemainingDuration(task) {
        if (task.duration === 0) {
            return 0
        } else {
            return 1
        }
    }

    // Forward Pass
    function calculateEsEf(link) {
        if (!link.valid) return
        let predIndex
        let cd
        const predTask = generateTask(link.pred_task_id)
        const succTask = generateTask(link.task_id)

        const statusValue = Math.max(handleTaskStatus[succTask.status_code], handleTaskStatus[predTask.status_code])
        const lag = parseFloat(link.lag_hr_cnt)
        const handleNegativeLag = lag < 0 ? lag : 0

        if (link.pred_type === 'FS') {
            predIndex = Math.max(Math.round(predTask.ef + (lag * statusValue)), predTask.ad + predTask.duration - checkRemainingDuration(predTask) + handleNegativeLag)
            cd = 1 - Math.max(handleTypes[succTask.task_type], handlePredTypes[predTask.task_type], 1 - checkRemainingDuration(predTask))
        } else if (link.pred_type === 'FF') {
            predIndex = Math.max(Math.round(predTask.ef + (lag * statusValue) - succTask.duration), predTask.ad + predTask.duration - checkRemainingDuration(predTask) - succTask.duration + handleNegativeLag)
            cd = 1 - Math.max(handleTypes[succTask.task_type], handlePredTypes[predTask.task_type], 1 - checkRemainingDuration(predTask))
        } else if (link.pred_type === 'SS') {
            predIndex = Math.max(Math.round(predTask.es + (lag * statusValue)), predTask.ad + handleNegativeLag)
            cd = 0
        } else {
            predIndex = Math.max(Math.round(predTask.es + (lag * statusValue) - succTask.duration), predTask.ad - succTask.duration + handleNegativeLag)
            cd = 0
        }

        predIndex = getLateralIndex(predIndex, predTask.cal_id, succTask.cal_id, cd)
        cpmMap.set(link.link_id, {...link, "ad": predIndex})

        if (predIndex > succTask.ad && predTask.task_type !== 'TT_LOE') {
            succTask.ad = predIndex
        }

        succTask.p_cnt -= 1

        if (succTask.p_cnt <= 0) {
            if (succTask.status_code === 'not started') {
                succTask.es = succTask.ad
            }
            if (succTask.duration === 0) {
                succTask.ef = succTask.status_code !== 'completed' ? succTask.ad : succTask.ef
            } else {
                succTask.ef = succTask.status_code !== 'completed' ? succTask.ad + succTask.duration - 1 : succTask.ef
            }
            if (succTask.ef === '') {
                if (succTask.duration === 0) {
                    succTask.ef = succTask.ad
                } else {
                    succTask.ef = succTask.ad + succTask.duration - 1
                }
            }

            cpmMap.set(succTask.task_code, {...succTask, p_cnt: succTask.p_sv})

            const successors = cpmMap.get(`${succTask.task_code}:succs`)
            for (const successor of successors) {
                calculateEsEf(generateLink(successor))
            }
        } else {
            cpmMap.set(succTask.task_code, succTask)
        }
    }
    for (const task of noPredTasks) {
        const successors = cpmMap.get(`${task}:succs`)
        for (const successor of successors) {
            calculateEsEf(generateLink(successor))
        }
    }

    function calculateAlap(link) {
        let succIndex
        let cd
        const predTask= generateTask(link.pred_task_id)
        const succTask= generateTask(link.task_id)

        const statusValue = Math.max(handleTaskStatus[succTask.status_code], handleTaskStatus[predTask.status_code])

        if (link.pred_type === 'FS') {
            succIndex = succTask.es
            cd = Math.max(handleTypesBp[predTask.task_type], handleTypesBp[succTask.task_type], 0 - checkRemainingDuration(succTask))
        }
        else if (link.pred_type === 'SS') {
            succIndex = succTask.es + predTask.duration
            cd = Math.max(handleTypesBp[predTask.task_type], handleTypesBp[succTask.task_type], 0 - checkRemainingDuration(succTask))
        }
        else if (link.pred_type === 'FF') {
            succIndex = succTask.ef
            cd = 0
        }
        else {
            succIndex = succTask.ef + predTask.duration
            cd = 0
        }

        return Math.round(getLateralIndex(succIndex, succTask.cal_id, predTask.cal_id, cd) -
            (parseFloat(link.lag_hr_cnt) * statusValue))
    }

    // Backward Pass
    function calculateLsLf(link) {
        let succIndex
        let cd
        const predTask = generateTask(link.pred_task_id)
        const succTask = generateTask(link.task_id)

        let localLateFinish = masterCalendarDict(globalLf / 1000, predTask.cal_id)
        if (isNaN(localLateFinish)) {
            localLateFinish = convertOutOfRangeDateToIndex(globalLf / 1000, predTask.cal_id)
        }
        const statusValue = Math.max(handleTaskStatus[succTask.status_code], handleTaskStatus[predTask.status_code])

        if (link.pred_type === 'FS') {
            succIndex = succTask.ls
            cd = Math.max(handleTypesBp[predTask.task_type], handleTypesBp[succTask.task_type], 0 - checkRemainingDuration(succTask))
        }
        else if (link.pred_type === 'SS') {
            succIndex = succTask.ls + predTask.duration
            cd = Math.max(handleTypesBp[predTask.task_type], handleTypesBp[succTask.task_type], 0 - checkRemainingDuration(succTask))
        }
        else if (link.pred_type === 'FF') {
            succIndex = succTask.lf
            cd = 0
        }
        else {
            succIndex = succTask.lf + predTask.duration
            cd = 0
        }

        succIndex = Math.round(getLateralIndex(succIndex, succTask.cal_id, predTask.cal_id, cd) -
            (parseFloat(link.lag_hr_cnt) * statusValue))

        cpmMap.set(link.link_id, {...link, af: succIndex})

        if (predTask.af === '') {
            predTask.af = localLateFinish
        }

        if (succIndex < parseInt(predTask.af) && succTask.task_type !== 'TT_LOE') {
            predTask.af = succIndex
        }

        if (predTask.cstr_type === 'CS_ALAP') {
            const alapFinish = calculateAlap(link)
            if (predTask.alap === '') {
                predTask.alap = localLateFinish
            }
            if (alapFinish < predTask.alap) {
                predTask.alap = alapFinish
            }
        }

        predTask.s_cnt -= 1

        if (predTask.s_cnt <= 0) {
            if (predTask.af < predTask.ef) {
                predTask.lf = predTask.ef
                predTask.ls = predTask.lf - predTask.duration + checkRemainingDuration(predTask)
            } else {
                predTask.lf = predTask.af
                predTask.ls = predTask.lf - predTask.duration + checkRemainingDuration(predTask)
            }
            if (predTask.alap !== '' && predTask.status_code === 'not started') {
                predTask.ef = Math.max(Math.min(predTask.lf, predTask.alap), predTask.ef)
                predTask.es = predTask.ef - predTask.duration + checkRemainingDuration(predTask)
            }

            predTask.float = predTask.lf - predTask.ef

            cpmMap.set(predTask.task_code, {...predTask, s_cnt: predTask.s_sv})

            const predecessors = cpmMap.get(`${predTask.task_code}:preds`)
            for (const predecessor of predecessors) {
                calculateLsLf(generateLink(predecessor))
            }
        }
        else {
            // else decrease s_cnt of predTask
            cpmMap.set(predTask.task_code, predTask)
        }
    }

    // determine globalLateFinish
    let globalLf = 0
    for (const taskId of noSuccTasks) {
        const thisLf = cpmMap.get(taskId).ef
        const calId = cpmMap.get(taskId).cal_id
        let thisLfDate = specificCalendarDict(thisLf, calId)
        if (isNaN(thisLfDate)) {
            thisLfDate = convertOutOfRangeIndexToDate(thisLf, calId)
        }
        if (thisLfDate > globalLf) {
            globalLf = thisLfDate
        }
        // console.log("date: ", new Date(thisLfDate * 1000).toDateString())
        if (thisLfDate * 1000 > globalLateFinish) {
            globalLateFinish = thisLfDate * 1000
        }
    }

    console.log("globalLateFinish: ", globalLateFinish, new Date(globalLateFinish).toDateString(), globalLf)
    cpmMap.set(`globalLf:${projectId}`, globalLf)
    globalLf = globalLf * 1000

    // Go through list of tasks with no successors
    for (const taskId of noSuccTasks) {
        const predecessors = cpmMap.get(`${taskId}:preds`)
        const task = generateTask(taskId)
        let localLateFinishSucc = masterCalendarDict(globalLf / 1000, task.cal_id)
        if (isNaN(localLateFinishSucc)) {
            localLateFinishSucc = convertOutOfRangeDateToIndex(globalLf / 1000, task.cal_id)
        }

        if (task.lf === '') {
            if (task.af === '') {
                task.af = localLateFinishSucc
            }
            if (task.af < task.ef) {
                task.lf = task.ef
                task.ls = task.lf - task.duration + checkRemainingDuration(task)
            } else {
                task.lf = task.af
                task.ls = task.lf - task.duration + checkRemainingDuration(task)
            }
        } else if (task.lf !== localLateFinishSucc) {
            if (task.ec !== 'n') {
                if(localLateFinishSucc < task.ec) {
                    task.af = localLateFinishSucc
                    if (task.af < task.ef) {
                        task.lf = task.ef
                        task.ls = task.lf - task.duration + checkRemainingDuration(task)
                    } else {
                        task.lf = task.af
                        task.ls = task.lf - task.duration + checkRemainingDuration(task)
                    }
                } else {
                    task.af = task.ec
                    if (task.af < task.ef) {
                        task.lf = task.ef
                        task.ls = task.lf - task.duration + checkRemainingDuration(task)
                    } else {
                        task.lf = task.af
                        task.ls = task.lf - task.duration + checkRemainingDuration(task)
                    }
                }
            } else {
                task.af = localLateFinishSucc
                if (task.af < task.ef) {
                    task.lf = task.ef
                    task.ls = task.lf - task.duration + checkRemainingDuration(task)
                } else {
                    task.lf = task.af
                    task.ls = task.lf - task.duration + checkRemainingDuration(task)
                }
            }
        }
        task.float = task.lf - task.ef
        cpmMap.set(task.task_code, task)
        for (const predecessor of predecessors) {
            calculateLsLf(generateLink(predecessor))
        }
    }
    console.log("CPM took " + (new Date().getTime() - timeStart) + "ms")

    return cpmMap
}
